const host = window.location.host;
const protocol = "https:";
const apiDomain = process.env.REACT_APP_API_DOMAIN || "guardians.one";
const apiDomainProd = "168game.online";
const apiDomainPrefix = process.env.REACT_APP_API_DOMAIN_PREFIX || "";
export const domains = {
  dev: `${apiDomainPrefix}dev-gapi.${apiDomain}/api`,
  qa: `${apiDomainPrefix}qa-help.vastplay.online.${apiDomain}/api`,
  int: `${apiDomainPrefix}int-gapi.${apiDomain}/api`,
  clinetInt: `gapi.cqgame.games/api`,
  prod: `help.${apiDomainProd}/api`,
  fifaProd: `thelp.vastplay.online/api`,
};
export const fetchGapiDomain = ({
  getDev = "dev-",
  getQa = "qa-",
  getInt = "int-",
  getFifaProd = "thelp.vastplay",
  isclinetInt = false,
}) => {
  const local = !!~host.indexOf(":");
  const isDev = !!~host.indexOf(getDev);
  const isQa = !!~host.indexOf(getQa);
  const isInt = !!~host.indexOf(getInt);
  const isFifaProd = !!~host.indexOf(getFifaProd);
  if (local || isDev) {
    return `${protocol}//${domains.dev}`;
  } else if (isQa) {
    return `${protocol}//${domains.qa}`;
    // } else if (is168) {
    //   return `${protocol}//${host}/api`;
  } else if (isFifaProd) {
    return `${protocol}//${domains.fifaProd}`;
  } else if (isInt) {
    return isclinetInt
      ? `${protocol}//${domains.clinetInt}`
      : `${protocol}//${domains.int}`;
  } else return `${protocol}//${domains.prod}`;
};
